export const dataMap = {
  activePower: '有功功率调节与控制能力',
  aliveSpeed: '极端（生存）风速（3秒最大值）',
  alreadyInstalledNumber: '该机型已安装数量',
  alternatorBearingType: '发电机轴承厂家/型号',
  alternatorType: '制造厂家/型号',
  alternatorWeight: '发电机',
  analysisSystem: '在线振动监测与分析系统',
  antiCorrosionTreatment: '表面防腐处理要求',
  apparentPower: '视在功率',
  automaticFireFightingSystem: '自动消防灭火系统',
  automaticGridConnectionLocking: '风电机组自动并网闭锁功能',
  automaticTimingFunction: '风电机组自动对时功能',
  bladeCylinderDiameter: '叶尖预弯',
  bladeLength: '叶片长度',
  bladeMaterial: '叶片材料',
  bladeMaxChordLength: '最大弦长',
  bladeSpeed: '叶片端线速度',
  bladeTipPrebending: '叶根圆柱段外径',
  bladeType: '制造厂家/型号',
  bladeWeight: '叶片（1套）',
  centralMonitoringSystemType: '中央监控系统厂家/型号',
  chassisType: '底架厂家/型号',
  compensationCapacitorsNum: '组数',
  compensationCapacity: '容量',
  controlUnitType: '控制单元类型',
  converterProtectionLevel: '防护等级',
  converterType: '变流器厂家/型号',
  coolingMode: '冷却方式',
  craneType: '厂家/型号',
  current: '额定电流（网侧/机侧）',
  dataCommunicationInterface: '数据通讯协议/接口',
  diameter: '风轮直径',
  dirInstrumentType: '风向仪厂家/型号',
  efficiency: '效率',
  electricPolesNum: '电机极数',
  engineRoomWeight: '机舱（不包括下列第2-5项）',
  existTempRange: '机组生存温度范围',
  fallProtection: '塔筒爬梯防跌落保护装置',
  frequencyRange: '电机频率范围',
  frequencyVariationRange: '输出频率变化范围',
  fullAvailabilityRatio: '设备可利用率（全场平均）',
  gearLevel: '齿轮级数',
  gearRatio: '齿轮传动比率',
  gearboxBearingType: '齿轮箱轴承厂家/型号',
  gearboxRatedPower: '额定功率',
  gearboxType: '制造厂家/型号',
  gearboxWeight: '齿轮箱',
  greaseModel: '润滑脂型号',
  gridConnectedSpeed: '并网转速',
  gridConnectedSwitchCapacity: '并网开关容量',
  gridConnectedSwitchType: '并网开关厂家/型号',
  gridCurrent: '电网电流适应能力',
  gridFrequency: '电网频率适应能力',
  gridVoltage: '电网电压适应能力',
  highVoltageRideThrough: '高电压穿越能力',
  hubAssemblyWeight: '轮毂装配重量',
  hubHeight: '轮毂高度',
  hydraulicUnitType: '制造厂家/型号',
  insulationLevel: '绝缘等级',
  ladderBooster: '爬梯助力器',
  launchEscapeSystem: '紧急逃生装置',
  life: '设计使用寿命',
  lightningProtection: '防雷措施',
  lightningProtectionDesignStandard: '防雷设计标准',
  lowVoltageRideThrough: '低电压穿越功能',
  lubricationMode: '润滑方式',
  mainAxisType: '主轴制造厂家/型号',
  mainBearingType: '主轴承制造厂家/型号',
  mainBrakeSystem: '主制动系统',
  mainControlSystemType: '主控系统厂家/型号',
  mainSwitchCabinetType: '主开关柜厂家/型号',
  mechanicalPower: '机械功率',
  nacelleType: '机舱罩厂家/型号',
  networkRelatedProtection: '风电机组具备的涉网保护功能',
  networkRelatedProtectionMethod: '涉网保护定值和参数（及获取方法）',
  pitchBearingType: '变桨轴承厂家/型号',
  pitchControllerType: '变桨控制器厂家/型号',
  pitchDriveMode: '变桨驱动方式',
  pitchDriveModeAfterPowerLoss: '失电后的变桨驱动模式（及动力源）',
  pitchDriverType: '变桨驱动器厂家/型号',
  pitchMotorType: '变桨电机(若有)制造厂家/型号',
  pitchReducerType: '变桨减速机(若有)制造厂家/型号',
  pitchType: '制造厂家/型号',
  powerControlSystem: '有功/无功功率控制系统',
  powerFactor: '软并网出力的功率因数',
  powerQuality: '风电机组输出的电能质量',
  powerRegulate: '功率调节方式',
  protectionLevel: '防护等级',
  provideSignalFaultRecording: '为故障录波提供信号（及接口）',
  ratedCurrent: '额定电流',
  ratedFrequency: '额定频率',
  ratedOutputCurrentConverter: '变流器额定输出电流（网侧/机侧）',
  ratedPower: '额定功率',
  ratedSpeed: '额定风速',
  ratedSpeedRange: '额定转速及其转速范围',
  ratedVoltage: '额定电压',
  reactivePower: '无功功率调节与控制能力',
  regulateOneQuarterRatedPower: '1/4额定功率',
  regulateRatedPower: '额定功率',
  regulateThreeQuartersRatedPower: '3/4额定功率',
  regulateTwoQuartersRatedPower: '2/4额定功率',
  remoteMonitoringSystemType: '远程监测系统厂家/型号',
  ridDispatchingCommunication: '电网调度信息通讯系统',
  runningTempRange: '机组运行温度范围',
  safetyBelt: '运行维护人员用全身型安全带',
  safetyRatio: '抗疲劳安全系数',
  secondBrakeSystem: '第二制动系统',
  securityLevel: '安全等级',
  shroudType: '导流罩厂家/型号',
  singleAvailabilityRatio: '设备可利用率（单机）',
  softGridConnectedDeviceType: '软并网装置厂家/类型',
  speedInstrumentType: '风速仪厂家/型号',
  startUpWspd: '大风后再启动风速',
  substituteType: '可作为完全替代品的厂家/型号（对每种品牌至少推荐1家）',
  sweptArea: '扫风面积',
  technicalSpecifications: '技术规格（起吊重量等）',
  tolerance: '对电网闪变、谐波值耐受能力',
  torque: '额定转矩',
  tubHubHeight: '轮毂高度（推荐）',
  tubType: '类型',
  // turbineType: '制造厂家/型号',
  // turbineTypeId: '机型ID',
  typeName: '机型名称',
  unitGroundResistance: '机组接地电阻值',
  // vendor: '厂商',
  voltage: '额定电压（网侧）',
  voltageAsymmetry: '电压不对称适应能力',
  wspdIn: '切入风速',
  wspdOut: '切出风速（10分钟平均值）',
  yawBearingLubrication: '偏航轴承润滑方式',
  yawBearingShape: '偏航轴承形式',
  yawBearingType: '偏航轴承厂家/型号',
  yawControlMode: '偏航控制方式',
  yawMotorType: '偏航电机(若有)厂家/型号',
  yawReducerType: '偏航减速器厂家/型号',
  yawType: '制造厂家/型号'
};

export const indexMap = {
  activePower: '14.6',
  aliveSpeed: '1.11',
  alreadyInstalledNumber: '1.17',
  alternatorBearingType: '4.14',
  alternatorType: '4.1',
  alternatorWeight: '20.2',
  analysisSystem: '15.2',
  antiCorrosionTreatment: '19.3',
  apparentPower: '5.2',
  automaticFireFightingSystem: '15.1',
  automaticGridConnectionLocking: '14.11',
  automaticTimingFunction: '14.12',
  bladeCylinderDiameter: '2.4',
  bladeLength: '2.2',
  bladeMaterial: '2.6',
  bladeMaxChordLength: '2.3',
  bladeSpeed: '2.7',
  bladeTipPrebending: '2.5',
  bladeType: '2.1',
  bladeWeight: '20.4',
  centralMonitoringSystemType: '13.1',
  chassisType: '18.2',
  compensationCapacitorsNum: '6.1',
  compensationCapacity: '6.2',
  controlUnitType: '12.2',
  converterProtectionLevel: '5.6',
  converterType: '5.1',
  coolingMode: '5.7',
  craneType: '17.1',
  current: '5.4',
  dataCommunicationInterface: '13.3',
  diameter: '1.4',
  dirInstrumentType: '10.9',
  efficiency: '3.6',
  electricPolesNum: '4.12',
  engineRoomWeight: '20.1',
  existTempRange: '1.15',
  fallProtection: '15.4',
  frequencyRange: '4.13',
  frequencyVariationRange: '5.5',
  fullAvailabilityRatio: '1.13',
  gearLevel: '3.2',
  gearRatio: '3.3',
  gearboxBearingType: '3.5',
  gearboxRatedPower: '4.2',
  gearboxType: '3.1',
  gearboxWeight: '20.3',
  greaseModel: '4.7',
  gridConnectedSpeed: '4.9',
  gridConnectedSwitchCapacity: '12.7.2',
  gridConnectedSwitchType: '12.7.1',
  gridCurrent: '14.4',
  gridFrequency: '14.5',
  gridVoltage: '14.3',
  highVoltageRideThrough: '14.2',
  hubAssemblyWeight: '20.5',
  hubHeight: '1.5',
  hydraulicUnitType: '11.1',
  insulationLevel: '4.11',
  ladderBooster: '15.3',
  launchEscapeSystem: '15.5',
  life: '1.16',
  lightningProtection: '16.2',
  lightningProtectionDesignStandard: '16.1',
  lowVoltageRideThrough: '14.1',
  lubricationMode: '4.6',
  mainAxisType: '7.1',
  mainBearingType: '7.2',
  mainBrakeSystem: '8.1',
  mainControlSystemType: '12.1',
  mainSwitchCabinetType: '12.7',
  mechanicalPower: '3.7',
  nacelleType: '18.1',
  networkRelatedProtection: '14.10',
  networkRelatedProtectionMethod: '14.14',
  pitchBearingType: '9.4',
  pitchControllerType: '9.5',
  pitchDriveMode: '9.2',
  pitchDriveModeAfterPowerLoss: '9.3',
  pitchDriverType: '9.6',
  pitchMotorType: '9.7',
  pitchReducerType: '9.8',
  pitchType: '9.1',
  powerControlSystem: '13.4',
  powerFactor: '12.5',
  powerQuality: '14.15',
  powerRegulate: '1.3',
  protectionLevel: '4.5',
  provideSignalFaultRecording: '14.13',
  ratedCurrent: '4.4',
  ratedFrequency: '12.3',
  ratedOutputCurrentConverter: '12.4',
  ratedPower: '1.2',
  ratedSpeed: '1.8',
  ratedSpeedRange: '4.8',
  ratedVoltage: '4.3',
  reactivePower: '14.7',
  regulateOneQuarterRatedPower: '',
  regulateRatedPower: '',
  regulateThreeQuartersRatedPower: '',
  regulateTwoQuartersRatedPower: '',
  remoteMonitoringSystemType: '13.2',
  ridDispatchingCommunication: '13.5',
  runningTempRange: '1.14',
  safetyBelt: '15.6',
  safetyRatio: '3.8',
  secondBrakeSystem: '8.2',
  securityLevel: '1.6',
  shroudType: '18.3',
  singleAvailabilityRatio: '1.12',
  softGridConnectedDeviceType: '12.6',
  speedInstrumentType: '10.8',
  startUpWspd: '1.10',
  substituteType: '2.9',
  sweptArea: '2.8',
  technicalSpecifications: '17.2',
  tolerance: '14.9',
  torque: '3.4',
  tubHubHeight: '19.2',
  tubType: '19.1',
  // turbineType: '1.1',
  // turbineTypeId: '1.1',
  typeName: '1.1',
  unitGroundResistance: '16.3',
  // vendor: '1.1',
  voltage: '5.3',
  voltageAsymmetry: '14.8',
  wspdIn: '1.7',
  wspdOut: '1.9',
  yawBearingLubrication: '10.7',
  yawBearingShape: '10.6',
  yawBearingType: '10.5',
  yawControlMode: '10.2',
  yawMotorType: '10.3',
  yawReducerType: '10.4',
  yawType: '10.1'
};

export const unitMap = {
  activePower: '',
  aliveSpeed: 'm/s',
  alreadyInstalledNumber: '台',
  alternatorBearingType: '',
  alternatorType: '',
  alternatorWeight: 't',
  analysisSystem: '',
  antiCorrosionTreatment: '',
  apparentPower: 'kVA',
  automaticFireFightingSystem: '',
  automaticGridConnectionLocking: '',
  automaticTimingFunction: '',
  bladeCylinderDiameter: 'mm',
  bladeLength: 'm',
  bladeMaterial: '',
  bladeMaxChordLength: 'mm',
  bladeSpeed: 'm/s',
  bladeTipPrebending: 'mm',
  bladeType: '',
  bladeWeight: 't',
  centralMonitoringSystemType: '',
  chassisType: '',
  compensationCapacitorsNum: '',
  compensationCapacity: 'kVar',
  controlUnitType: '',
  converterProtectionLevel: '',
  converterType: '',
  coolingMode: '',
  craneType: '',
  current: 'A',
  dataCommunicationInterface: '',
  diameter: 'm',
  dirInstrumentType: '',
  efficiency: '',
  electricPolesNum: '',
  engineRoomWeight: 't',
  existTempRange: '°C',
  fallProtection: '',
  frequencyRange: 'Hz',
  frequencyVariationRange: 'Hz',
  fullAvailabilityRatio: '%',
  gearLevel: '',
  gearRatio: '',
  gearboxBearingType: '',
  gearboxRatedPower: 'kW',
  gearboxType: '',
  gearboxWeight: 't',
  greaseModel: '',
  gridConnectedSpeed: 'rpm',
  gridConnectedSwitchCapacity: '',
  gridConnectedSwitchType: '',
  gridCurrent: '',
  gridFrequency: '',
  gridVoltage: '',
  highVoltageRideThrough: '',
  hubAssemblyWeight: 't',
  hubHeight: 'm',
  hydraulicUnitType: '',
  insulationLevel: '',
  ladderBooster: '',
  launchEscapeSystem: '',
  life: 'Year',
  lightningProtection: '',
  lightningProtectionDesignStandard: '',
  lowVoltageRideThrough: '',
  lubricationMode: '',
  mainAxisType: '',
  mainBearingType: '',
  mainBrakeSystem: '',
  mainControlSystemType: '',
  mainSwitchCabinetType: '',
  mechanicalPower: 'kW',
  nacelleType: '',
  networkRelatedProtection: '',
  networkRelatedProtectionMethod: '',
  pitchBearingType: '',
  pitchControllerType: '',
  pitchDriveMode: '',
  pitchDriveModeAfterPowerLoss: '',
  pitchDriverType: '',
  pitchMotorType: '',
  pitchReducerType: '',
  pitchType: '',
  powerControlSystem: '',
  powerFactor: '',
  powerQuality: '',
  powerRegulate: '',
  protectionLevel: '',
  provideSignalFaultRecording: '',
  ratedCurrent: 'A',
  ratedFrequency: '',
  ratedOutputCurrentConverter: '',
  ratedPower: 'kW',
  ratedSpeed: 'm/s',
  ratedSpeedRange: 'rpm',
  ratedVoltage: 'V',
  reactivePower: '',
  regulateOneQuarterRatedPower: '',
  regulateRatedPower: '',
  regulateThreeQuartersRatedPower: '',
  regulateTwoQuartersRatedPower: '',
  remoteMonitoringSystemType: '',
  ridDispatchingCommunication: '',
  runningTempRange: '°C',
  safetyBelt: '',
  safetyRatio: '',
  secondBrakeSystem: '',
  securityLevel: '',
  shroudType: '',
  singleAvailabilityRatio: '%',
  softGridConnectedDeviceType: '',
  speedInstrumentType: '',
  startUpWspd: 'm/s',
  substituteType: '',
  sweptArea: '㎡',
  technicalSpecifications: '',
  tolerance: '',
  torque: '',
  tubHubHeight: 'm',
  tubType: '',
  // turbineType: '',
  // turbineTypeId: '',
  typeName: '',
  unitGroundResistance: 'Ω',
  // vendor: '',
  voltage: 'V',
  voltageAsymmetry: '',
  wspdIn: 'm/s',
  wspdOut: 'm/s',
  yawBearingLubrication: '',
  yawBearingShape: '',
  yawBearingType: '',
  yawControlMode: '',
  yawMotorType: '',
  yawReducerType: '',
  yawType: ''
};
export const assemblyMap = {
  generatorAssemblyWeight: '重量',
  generatorAssemblyLength: '尺寸：长',
  generatorAssemblyWide: '尺寸：宽',
  generatorAssemblyHigh: '尺寸：高',
  engineRoomWeight: '重量',
  engineRoomLength: '尺寸：长',
  engineRoomWide: '尺寸：宽',
  engineRoomHigh: '尺寸：高',
  hubWeight: '重量',
  hubLength: '尺寸：长',
  hubWide: '尺寸：宽',
  hubHigh: '尺寸：高',
  bladeSingleWeight: '重量',
  bladeSingleLength: '尺寸：长',
  bladeMaxChordLength: '最大弦长',
  bladeCylinderDiameter: '叶根圆柱段外径',
  bladeTipPrebending: '叶尖预弯',
  bladeThreeWeight: '重量'
};
export const assemblyMapUnit = {
  generatorAssemblyWeight: 'kg',
  generatorAssemblyLength: 'm',
  generatorAssemblyWide: 'm',
  generatorAssemblyHigh: 'm',
  engineRoomWeight: 'kg',
  engineRoomLength: 'm',
  engineRoomWide: 'm',
  engineRoomHigh: 'm',
  hubWeight: 'kg',
  hubLength: 'm',
  hubWide: 'm',
  hubHigh: 'm',
  bladeSingleWeight: 'kg',
  bladeSingleLength: 'm',
  bladeMaxChordLength: 'mm',
  bladeCylinderDiameter: 'mm',
  bladeTipPrebending: 'mm',
  bladeThreeWeight: 'kg'
};
export const costParameterMap = {
  blade: '叶片',
  pitchBearing: '变桨轴承',
  pitchControlSystem: '变桨系统',
  pitchReducer: '变桨减速机',
  hub: '轮毂',
  principalAxis: '主轴 （选项）',
  mainFrame: '主机架',
  spindleBearing: '主轴轴承（选项）',
  mainShaftBearingSeat: '主轴轴承座（选项）',
  auxiliaryRack: '辅助机架（选项）',
  yawBearing: '偏航轴承',
  yawBrake: '偏航刹车',
  yawDrive: '偏航驱动',
  engineCompartmentCover: '机舱罩壳',
  hydraulicSystem: '液压系统',
  mainGearBox: '主齿轮箱（选项）',
  coupling: '联轴器（选项）',
  alternator: '发电机',
  generatorCoolingSystem: '发电机冷却系统',
  converter: '变流器',
  controlSystem: '控制系统',
  monitoringSystem: '监控系统',
  powerCable: '动力电缆',
  busBar: '母线（管母/导电轨）',
  highStrengthBolt: '高强度螺栓',
  automaticLubricationSystem: '自动润滑系统',
  elasticSupport: '弹性支撑（选项）',
  slipRingMasterPlan: '滑环总图 （选项）',
  other: '其他',
  specialTool: '备品备件、易耗品、专用工具',
  total1: '总计1',
  unitPowerCost1: '单位功率成本1',
  manufacturingCost: '制造费用、安装调试费用',
  manufacturingUnitCost: '单位千瓦制造费用、安装调试费用',
  transportCharge: '运输费',
  transportUnitCharge: '单位千瓦运输费',
  specialSupply: '特殊供货',
  specialUnitSupply: '单位千瓦特殊供货',
  taxesOther: '税费及其他',
  taxesOtherUnit: '单位千瓦税费及其他',
  total2: '总计2',
  unitPowerCost2: '单位功率成本2'
};
export const costParameterUnitMap = {
  unitPowerCost1: '元/kW',
  manufacturingUnitCost: '元/kW',
  transportUnitCharge: '元/kW',
  specialUnitSupply: '元/kW',
  taxesOtherUnit: '元/kW',
  unitPowerCost2: '元/kW'
};

export const unitGeneratorMap = {
  type: '发电机类型',
  // name: '发电机名称',
  exportPower: '出口功率',
  ratedCurrent: '额定电流',
  ratedVoltage: '额定电压',
  maxCurrent: '正常运行最大电流',
  noLoadBackEmf: '空载反电动势',
  voltageUnbalance: '电压不平衡度',
  powerFactor: '功率因数',
  ratedEfficiency: '额定效率',
  ratedTorque: '额定转矩',
  maxShortCircuitMoment: '最大短路力矩',
  maxShortCircuitCurrent: '最大短路电流',
  poleNumber: '极数',
  ratedSpeed: '额定转速',
  ratedFrequency: '额定频率',
  maxRunningSpeed: '正常运行最大转速（带电）',
  noLoadMaximumSpeed: '发电机空载最大转速',
  statorWindingType: '定子绕组类型',
  insulationGrade: '绝缘等级',
  heatGrade: '耐热等级',
  temperatureRiseLimitStatorWinding: '定子绕组温升限值（ETD）',
  coolingMode: '冷却方式',
  permanentMagnetType: '永磁体类型',
  temperatureLimitPermanentMagnet: '永磁体温度限值',
  bearingTemperatureLimit: '轴承温度限值',
  vibrationDisplacementLimit: '振动位移限值',
  noiseLevel: '噪声等级',
  protectionLevel: '防护等级',
  motorExternalDiameter: '电机外径',
  motorLength: '电机长度',
  momentInertia: '转动惯量',
  rotationDirection: '旋转方向',
  totalWeight: '总重量',
  designLife: '设计寿命'
};

export const generatorUnitMap = {
  type: '',
  // name: '',
  exportPower: 'kW',
  ratedCurrent: 'A',
  ratedVoltage: 'V',
  maxCurrent: 'A',
  noLoadBackEmf: 'V',
  voltageUnbalance: '%',
  powerFactor: '',
  ratedEfficiency: '%',
  ratedTorque: 'kNm',
  maxShortCircuitMoment: 'kNm',
  maxShortCircuitCurrent: 'A',
  poleNumber: '',
  ratedSpeed: 'r/min',
  ratedFrequency: 'Hz',
  maxRunningSpeed: 'r/min',
  noLoadMaximumSpeed: 'r/min',
  statorWindingType: '',
  insulationGrade: '',
  heatGrade: '',
  temperatureRiseLimitStatorWinding: 'K',
  coolingMode: '',
  permanentMagnetType: '',
  temperatureLimitPermanentMagnet: '℃',
  bearingTemperatureLimit: '℃',
  vibrationDisplacementLimit: 'μm',
  noiseLevel: 'dB',
  protectionLevel: '',
  motorExternalDiameter: 'mm',
  motorLength: 'mm',
  momentInertia: 'kg.m2',
  rotationDirection: '',
  totalWeight: 't',
  designLife: '年'
};

export const unitConverterMap = {
  // name: '变流器名称',
  meshSideRatedPower: '网侧变流器额定功率',
  meshSideRatedVoltage: '网侧变流器额定电压',
  meshSideRatedCurrent: '网侧变流器额定电流',
  meshSideShortTimeOvercurrent: '网侧变流器短时过电流',
  meshSideOperatingRange: '网侧变流器电网频率运行范围',
  machineSideRatedPower: '机侧变流器额定功率',
  machineSideRatedCurrent: '机侧变流器额定电流',
  machineSideShortTimeOvercurrent: '机侧变流器短时过电流',
  machineSideOperatingRange: '机侧变流器电压运行范围',
  machineSideOperatingRangeOutput: '机侧变流器频率运行范围输出',
  switchingFrequency: '开关频率',
  machineSidePort: '机侧变流器端口',
  machineSideMaxOutputAcVoltage: '机侧变流器最高输出交流电压',
  efficiency: '效率',
  busVoltageReleaseTime: '母线电压泄放时间',
  powerFactor: '功率因数',
  shortCircuitAbility: '短路电流分断能力',
  cabinetProtectionLevels: '柜体防护等级',
  cabinetColor: '柜体颜色',
  contourSize: '外形尺寸（宽*高*深）',
  machineSideOutletDirection: '机侧出线方向',
  meshSideOutletDirection: '网侧出线方向',
  coolingMode: '冷却方式'
};

export const unitConverterUnitMap = {
  // name: '',
  meshSideRatedPower: 'kW',
  meshSideRatedVoltage: 'V',
  meshSideRatedCurrent: 'A',
  meshSideShortTimeOvercurrent: 'A',
  meshSideOperatingRange: 'Hz',
  machineSideRatedPower: 'kW',
  machineSideRatedCurrent: 'A',
  machineSideShortTimeOvercurrent: 'A',
  machineSideOperatingRange: 'V',
  machineSideOperatingRangeOutput: 'Hz',
  switchingFrequency: 'kHz',
  machineSidePort: 'du/dt（V/μs）',
  machineSideMaxOutputAcVoltage: 'V',
  efficiency: '',
  busVoltageReleaseTime: '',
  powerFactor: '',
  shortCircuitAbility: 'Ka',
  cabinetProtectionLevels: '',
  cabinetColor: '',
  contourSize: 'mm',
  machineSideOutletDirection: '',
  meshSideOutletDirection: '',
  coolingMode: ''
};

export const unitCableMap = {
  machineSidePowerCableNumber: '根数',
  machineSidePowerCableStandard: '规格',
  meshSideEarthingCableNumber: '根数',
  meshSideEarthingCableStandard: '规格',
  meshSidePowerCableNumber: '根数',
  meshSidePowerCableStandard: '规格',
  busType: '母线型式'
};
export const unitCableUnitMap = {
  machineSidePowerCableNumber: '根',
  machineSidePowerCableStandard: 'mm²',
  meshSideEarthingCableNumber: '根',
  meshSideEarthingCableStandard: 'mm²',
  meshSidePowerCableNumber: '根',
  meshSidePowerCableStandard: 'mm²',
  busType: ''
};

export const unitBladeMap = {
  type: '叶片型号',
  // name: '叶片名称',
  lblade: '叶片长度L_blade',
  bpower: '功率等级b_power',
  windClass: '风区wind_class',
  chordMax: '最大弦长Chord_max',
  twistRoot: '叶根圆柱段扭角Twist_root',
  prebendxMax: '叶尖最大预弯Prebendx_max',
  prebendyMax: '叶尖最大后掠量Prebendy_max',
  ifFlange: '是否有叶根法兰If_flange',
  thRoot: '叶根最大铺层厚度Th_root',
  droot: '叶根节圆直径D_root',
  mxRoot: '叶根极限载荷Mx_root',
  myRoot: '叶根极限载荷My_root',
  mxyRoot: '叶根极限载荷Mxy_root',
  capMat: '主梁帽材质Cap_mat',
  widthSc: '主梁帽宽度Width_SC',
  nplySc: '主梁帽层数N_ply_SC',
  ifWebSc: '腹板是否关于主梁帽参考线对称If_Web_SC',
  proportion: '腹板间距占主梁帽宽度的比例',
  webInclination: '腹板倾斜角度',
  udWidth: '后缘UD宽度',
  udNumber: '后缘UD层数',
  locChordmax: '最大弦长截面位置Loc_chordmax',
  twistChordmax: '最大弦长截面扭角Twist_chordmax',
  thrChordmax: '最大弦长截面相对厚度Thr_chordmax',
  mxChordmax: '最大弦长截面极限载荷Mx_chordmax',
  myChordmax: '最大弦长截面极限载荷My_chordmax',
  mxyChordmax: '最大弦长截面极限载荷Mxy_chordmax',
  gxChordmax: '最大弦长截面摆振刚度Gx_chordmax',
  gyChordmax: '最大弦长截面挥舞刚度Gy_chordmax',
  gzChordmax: '最大弦长截面扭转刚度Gz_chordmax'
};
// bpower: "2000"
// capMat: "11"
// chordMax: "1"
// droot: "7" **
// gxChordmax: "25"
// gyChordmax: "26"
// gzChordmax: "27"
// ifFlange: "5"
// ifWebSc: "14"
// lblade: "156" **
// locChordmax: "19"
// mxChordmax: "22"
// mxRoot: "8"
// mxyChordmax: "24"
// mxyRoot: "10"
// myChordmax: "23"
// myRoot: "9"
// name: "叶片A"
// nplySc: "13" **
// pointId: 14 **
// prebendxMax: "3"
// prebendyMax: "4"
// proportion: "15"
// thRoot: "6"
// thrChordmax: "21"
// twistChordmax: "20"
// twistRoot: "2"
// type: "a-1"
// udNumber: "18"
// udWidth: "17"
// webInclination: "16"
// widthSc: "12"
// windClass: "A"
export const unitBladeMapUnit = {
  type: '',
  // name: '',
  lblade: 'm',
  bpower: 'kW',
  windClass: '',
  chordMax: 'm',
  twistRoot: 'o',
  prebendxMax: 'm',
  prebendyMax: 'm',
  ifFlange: '',
  thRoot: 'mm',
  droot: 'mm',
  mxRoot: 'kNm',
  myRoot: 'kNm',
  mxyRoot: 'kNm',
  capMat: '',
  widthSc: 'm',
  nplySc: '',
  ifWebSc: '',
  proportion: '',
  webInclination: 'o',
  udWidth: 'm',
  udNumber: '',
  locChordmax: 'm',
  twistChordmax: 'o',
  thrChordmax: '',
  mxChordmax: 'kNm',
  myChordmax: 'kNm',
  mxyChordmax: 'kNm',
  gxChordmax: 'kNm^2',
  gyChordmax: 'kNm^2',
  gzChordmax: 'kNm^2'
};
export const UnitTubeMap = {
  towerMaterialSpecification: '塔筒材料规格',
  basicInterfaceType: '基础接口型式',
  hubHeight: '轮毂高度',
  weightAccessories: '重量附件',
  lengthTotal: '长度总计',
  weightTotal: '重量总计',
  tubeName: '塔筒段名称',
  length: '长度（m）',
  heartHeight: '重心高度（m）',
  weight: '重量（kg）',
  upperFlange: '上法兰外径（m）',
  downFlange: '下法兰外径（m）'
};
